import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=9048c9c4&scoped=true"
import script from "./Units.vue?vue&type=script&lang=ts"
export * from "./Units.vue?vue&type=script&lang=ts"
import style0 from "./Units.vue?vue&type=style&index=0&id=9048c9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9048c9c4",
  null
  
)

export default component.exports